"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerVideo = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBannerVideo = (param)=>{
    let { size, backgroundVideo, promoBannerType } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!(backgroundVideo === null || backgroundVideo === void 0 ? void 0 : backgroundVideo.id)) {
        return null;
    }
    var _backgroundVideo_playInLoop;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Video, {
        autoPlay: true,
        playsInline: true,
        muted: true,
        size: size,
        promoBannerType: promoBannerType,
        src: backgroundVideo.id,
        loop: (_backgroundVideo_playInLoop = backgroundVideo.playInLoop) !== null && _backgroundVideo_playInLoop !== void 0 ? _backgroundVideo_playInLoop : true,
        "data-testid": getTestId(_constants.BANNER_VIDEO)
    });
};
exports.PromoBannerVideo = PromoBannerVideo;
